/**
 * Recenter camera back to facing down negative Z axis at 0, 0, 0.
 */
AFRAME.registerComponent('recenter', {
  schema: {
    enabled: {default: true}
  },

  init: function () {
    var sceneEl = this.el.sceneEl;
    this.recenter = this.recenter.bind(this);

    document.querySelectorAll('[tracked-controls]').forEach(controlEl => {
      controlEl.addEventListener('menudown', this.recenter);
      controlEl.addEventListener('thumbstickdown', this.recenter);
    });

    this.el.addEventListener('recenter', this.recenter);
  },

  recenter: (function () {
    var euler = new THREE.Euler();
    var matrix = new THREE.Matrix4();
    var rotationMatrix = new THREE.Matrix4();
    var translationMatrix = new THREE.Matrix4();

    return function () {
      const el = this.el;

      if (!this.data.enabled) { return; }

      const camera = el.sceneEl.camera.el.object3D;

      // Reset matrix.
      matrix.identity();

      // Create matrix to reset Y rotation.
      euler.set(0, -1 * camera.rotation.y, 0);
      rotationMatrix.makeRotationFromEuler(euler);

      // Create matrix to zero position.
      translationMatrix.makeTranslation(-1 * camera.position.x, 0, -1 * camera.position.z);

      // Multiply and decompose back to object3D.
      matrix.multiply(rotationMatrix).multiply(translationMatrix);
      matrix.decompose(el.object3D.position, el.object3D.quaternion, el.object3D.scale);
      el.object3D.updateMatrixWorld(true);
      el.emit('recentered', null, false);
    };
  })()
});
if (module.hot && window.AFRAME) {
  const componentNames = ['recenter',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
